import { useCallback, useEffect, useState } from "react";
import {
  CUSTOMER_AUTH_CHANGED_EVENT,
  getCustomerAccessToken,
  getStoredUserData,
} from "./customerSession";
import { CUSTOMER_SESSION_EXPIRED_EVENT } from "../api/customerHttpClient";

export function readCustomerAuthSnapshot() {
  const stored = getStoredUserData();
  const userData = Array.isArray(stored) ? stored[0] || null : stored;
  const hasUserIdentity = Boolean(
    userData?.id || userData?.public_id || userData?.publicId,
  );
  const hasToken = Boolean(getCustomerAccessToken());
  return {
    userData: userData || null,
    hasUserIdentity,
    hasToken,
    isLoggedIn: hasUserIdentity || hasToken,
  };
}

export function useCustomerAuth() {
  const [auth, setAuth] = useState(readCustomerAuthSnapshot);

  const refresh = useCallback(() => {
    setAuth(readCustomerAuthSnapshot());
  }, []);

  useEffect(() => {
    refresh();
    const handleVisibility = () => {
      if (document.visibilityState === "visible") refresh();
    };
    window.addEventListener("storage", refresh);
    window.addEventListener("focus", refresh);
    document.addEventListener("visibilitychange", handleVisibility);
    window.addEventListener(CUSTOMER_AUTH_CHANGED_EVENT, refresh);
    window.addEventListener(CUSTOMER_SESSION_EXPIRED_EVENT, refresh);
    return () => {
      window.removeEventListener("storage", refresh);
      window.removeEventListener("focus", refresh);
      document.removeEventListener("visibilitychange", handleVisibility);
      window.removeEventListener(CUSTOMER_AUTH_CHANGED_EVENT, refresh);
      window.removeEventListener(CUSTOMER_SESSION_EXPIRED_EVENT, refresh);
    };
  }, [refresh]);

  return auth;
}
